import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { inject, observer } from 'mobx-react';
import { Grid } from 'react-bootstrap';
import Helmet from 'react-helmet';
import { formatLandscapeMetaImageUrl } from '../utils/imageUtils';
import { normalizeCanonicalUrl } from '../utils/urlUtils';
import hostname from '../../common/env/constants';

@withRouter
@observer
class App extends React.Component {
    render() {
        const childrenWithProps = React.Children.map(
            this.props.children,
            child => {
                return React.cloneElement(child, {
                    ...this.props,
                    key: this.props.location.pathname
                });
            }
        );

        let { pathname } = this.props.location;

        if (pathname[0] !== '/') {
            pathname = '/' + pathname;
        }

        if (pathname === '/') {
            pathname = '';
        }

        const meta = {
            canonical: normalizeCanonicalUrl(hostname + pathname),
            description:
                'The most up-to-date and comprehensive analysis of San Francisco home prices, values, conditions & trends of the San Francisco Bay Area residential real estate market.',
            keywords:
                'San Francisco, Homes for Sale, Bay Area, Real Estate, Investment',
            name: 'Compass',
            title: 'Bay Area market reports - Compass',
            type: 'blog'
        };

        return (
            <Grid fluid>
                <Helmet>
                    <title>{meta.title}</title>
                    <link rel="canonical" href={meta.canonical} />
                    <meta name="description" content={meta.description} />
                    <meta name="keywords" content={meta.keywords} />
                    <meta property="og:image" content={meta.image} />
                    <meta property="og:title" content={meta.title} />
                    <meta property="og:url" content={meta.canonical} />
                    <meta property="og:name" content={meta.name} />
                    <meta property="og:type" content={meta.type} />
                    <meta
                        property="og:description"
                        content={meta.description}
                    />
                </Helmet>
                <ReactCSSTransitionGroup
                    component="div"
                    transitionName="change-page"
                    transitionEnterTimeout={400}
                    transitionLeaveTimeout={400}
                >
                    {childrenWithProps}
                </ReactCSSTransitionGroup>
                <div className="compass-footer">
                    <small>Copyright © 2018 Bay Area Market Reports</small>
                </div>
            </Grid>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/common/components/App.jsx